/**
 * Get a google maps URL for a given address
 * @param {string} address The address to search for
 * @returns {string} URL string for google maps
 */
export function mapurl(address: string): string {
	const url = 'https://www.google.com/maps/search/?api=1&query=' + address;
	return url;
}
